import React, {PropTypes} from "react";
import Button from "react-bootstrap/lib/Button";
import axios from "axios";
import moment from "moment";
import toastr from "toastr";

let cleanString = (string) => {
  string = string.replace(/"/g, "");
  string = string.replace(/\r?\n|\r/, "");
  return string;
};

let cleanStringArray = (arrayOfStrings) => {
  for (let i = 0; i < arrayOfStrings.length; i++) {
    arrayOfStrings[i] = cleanString(arrayOfStrings[i]);
  }
  return arrayOfStrings
};
function validate(csv) {
  let row = csv.split('\n');
  let header = row[0].split(',');
  header = cleanStringArray(header);
  header = header.map((element) => {
    return element.split(' ').join('').toLowerCase();
  });

  return true;
}
function csvJSON(csv) {

  var lines = csv.split("\n");
  var result = [];
  var headers = lines[0].split(",");
  for (var k = 0; k < headers.length; k++) {
    headers[k] = headers[k].replace(/['"]+/g, '');
  }
  for (var i = 1; i < lines.length; i++) {
    var obj = {};
    var currentline = lines[i].split(",");
    if (currentline[0] == "") {
      currentline[0] = null;
    }
    var date = new Date();
    for (var j = 0; j < headers.length; j++) {
      if (j == headers.length - 1)
        headers[j] = 'officeLocation';
      if (currentline[j] != null)
        if (currentline[j].trim().length == 0) {
          obj[headers[j]] = null;
        }
        else {
          obj[headers[j]] = encodeURI(cleanString(currentline[j]));
        }
      else
        obj[headers[j]]=null;
    }
    result.push(obj);
  }
  return result; //JSON
}
function csvJSONLeave(csv) {
  var lines = csv.split("\n");
  var result = [];
  var headers = lines[0].split(",");
  for (var k = 0; k < headers.length; k++) {
    headers[k] = headers[k].replace(/['"]+/g, '');
  }
  for (var i = 1; i < lines.length; i++) {
    var obj = {};
    var currentline = lines[i].split(",");
    if (currentline[0] == "" || currentline[0] == null) {
      debugger;
      currentline[0] = null;
    }
    for (var j = 0; j < headers.length; j++) {
        try {
            if (typeof(currentline[j]) === 'string')
                currentline[j] = currentline[j].trim();
            else
                currentline[j] = null;
            if(currentline[j] != null) {
                switch (j) {
                    case 0:
                        obj['empId'] = currentline[0];
                        break;
                    case 1:
                        obj['leaveBalance'] = currentline[1];
                        break;
                    case 2:
                        if (typeof(currentline[2]) === 'string') {
                            obj['reason'] = currentline[2].trim();
                        }
                        else
                            obj['reason'] = null;
                        break;
                }
            }
        }
        catch (error) {
            toastr.error("Parse Error Occurred");
        }
    }
      result.push(obj);
  }
  return result; //JSON
}
function csvJSONPersonal(csv) {
  var lines = csv.split("\n");
  var result = [];
  var headers = lines[0].split(",");
  for (var k = 0; k < headers.length; k++) {
    headers[k] = headers[k].replace(/['"]+/g, '');
  }
  console.log(headers);
  for (var i = 1; i < lines.length; i++) {
    var obj = {};
    var currentline = lines[i].split(",");
    if (currentline[i] == "" || currentline[i] == null) {
      currentline[i] = null;
    }
    var date = new Date();
    for (var j = 0; j < headers.length; j++) {
      if(j==1)
        obj["empDOB"] = currentline[j];
      if (j == headers.length - 1)
        headers[j] = 'empUAN';
      if (currentline[j] != null) {
        if (currentline[j].trim().length == 0) {
          obj[headers[j]] = null;
        }
        else {
          obj[headers[j]] = (cleanString(currentline[j]));
        }
      }
    }
    result.push(obj);
  }
  return result; //JSON
}
function csvJSONExit(csv) {
  var lines = csv.split("\n");
  var result = [];
  var headers = lines[0].split(",");
  for (var k = 0; k < headers.length; k++) {
    headers[k] = headers[k].replace(/['"]+/g, '');
  }
  for (var i = 1; i < lines.length; i++) {
    var obj = {};
    var currentline = lines[i].split(",");
    if (currentline[i] == "" || currentline[i] == null) {
      currentline[i] = null;
    }
    var date = new Date();
    for (var j = 0; j < headers.length; j++) {
      if (j == headers.length - 1)
        headers[j] = 'dateOfJoining';
      if (currentline[j] != null) {
        if (currentline[j].trim().length == 0) {
          obj[headers[j]] = null;
        }
        else {
          obj[headers[j]] = (cleanString(currentline[j]));
        }
      }
    }
    result.push(obj);
  }
  return result; //JSON
}


class UploadHome extends React.Component {

  constructor() {
    super();
    this.state = {value: "",
      requestObject: [],
      leaveObject: [],
      exitObject: [],
      professional: true,
      leave: true,
      absorption: true,
      personal: true,
      message: "",
      leaveValue:"",
    exitValue: "",
    personaValue: "",
    personalObject: []};
    this.handleProfessionalChange = this.handleProfessionalChange.bind(this);
    this.handleLeaveChange = this.handleLeaveChange.bind(this);
    this.handleAbsorptionChange = this.handleAbsorptionChange.bind(this);
    this.handlePersonalChange = this.handlePersonalChange.bind(this);
  }

  handlePersonalChange(event)
  {
    let files = event.target.files;
    if (files.length === 1) {
      let reader = new FileReader();
      reader.onload = function () {
        let csv = reader.result;
        if (validate(csv) === true) {

          let result = (csvJSONPersonal(csv));
          console.log(result);
          result.filter((node)=> {
            if (node.empId == null)
              return false;
            else
              return true;
          });
          this.setState({personalObject: result, personalLength: result.length, personal: false})
        }
        else {
          alert("Please check the table format of the csv uploaded.")
        }
      }.bind(this);
      if (event.target.value != null || event.target.value == "")
        this.setState({personalValue: event.target.value});
      else
        this.setState({personalValue: ""});
      reader.readAsText(files[0], 'UTF-8');
    }

  }


  handleAbsorptionChange(event)
  {
    let files = event.target.files;
    if (files.length === 1) {
      let reader = new FileReader();
      reader.onload = function () {
        let csv = reader.result;
        if (validate(csv) === true) {

          let result = (csvJSONExit(csv));
          console.log(result);
          result.filter((node)=> {
            if (node.empId == null)
              return false;
            else
              return true;
          });
          this.setState({exitObject: result, exitLength: result.length, absorption: false})
        }
        else {
          alert("Please check the table format of the csv uploaded.")
        }
      }.bind(this);
      if (event.target.value != null || event.target.value == "")
        this.setState({exitValue: event.target.value});
      else
        this.setState({exitValue: ""});
      reader.readAsText(files[0], 'UTF-8');
    }

  }

  handleLeaveChange(event) {
    let files = event.target.files;
    if (files.length === 1) {
      let reader = new FileReader();
      reader.onload = function () {
        let csv = reader.result;
        if (validate(csv) === true) {

          let result = (csvJSONLeave(csv));
          console.log(result);
          result.filter((node)=> {
            if (node.empId == null)
              return false;
            else
              return true;
          });
          this.setState({leaveObject: result, length: result.length, leave: false})
        }
        else {
          alert("Please check the table format of the csv uploaded.")
        }
      }.bind(this);
      if (event.target.value != null || event.target.value == "")
        this.setState({leaveValue: event.target.value});
      else
        this.setState({leaveValue: ""});
      reader.readAsText(files[0], 'UTF-8');
    }
  }
  handleProfessionalChange(event) {
    let files = event.target.files;
    if (files.length === 1) {
      let reader = new FileReader();
      reader.onload = function () {
        let csv = reader.result;
        if (validate(csv) === true) {
          let result = (csvJSON(csv));
          result.filter((node)=> {
            if (node.empId == null)
              return false;
            else
              return true;
          });
          this.setState({requestObject: result, length: result.length, professional: false})
        }
        else {
          alert("Please check the table format of the csv uploaded.")
        }
      }.bind(this);
      if (event.target.value != null || event.target.value == "")
        this.setState({value: event.target.value});
      else
        this.setState({value: ""})
      reader.readAsText(files[0], 'UTF-8');
    }

  }


  render() {
    return (
      <div style={{'padding':'20px'}}>

        <h2><u>Professional Details Upload</u></h2>
        <div>
          <input value={this.state.value}
                 type="file" accept=".csv" name="file" onChange={this.handleProfessionalChange}/>
          <Button
            //className="btn-lg"
            disabled={this.state.professional}
            onClick={()=> {

              axios.post(process.env.REQ_URL + "/admin/upload",
                {data: this.state.requestObject},
                {withCredentials: true ,
                  headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                this.setState({requestObject: response.data.data, professional: true, message: "Upload Complete"})

              }).catch((error)=> {

              })
            }}>Upload</Button>
        </div>
        <h2>{this.state.message}</h2>
        <nav>
          <ul style={{'padding':'inherit', 'overflow': 'hidden', 'overflowY': 'scroll', 'overflowX': 'scroll', height: '300px', width: '100%', border: 'thin solid'}}>
            <table className="table table-bordered table-striped">
              <thead>
              <tr>
                <th>empId</th>
                <th>reportingTo</th>
                <th>department</th>
                <th>subDepartment</th>
                <th>function</th>
                <th>vertical</th>
                <th>verticalHead</th>
                <th>payroll</th>
                <th>officeLocation</th>
                <th>Message</th>

              </tr>
              </thead>
              <tbody>
              {this.state.requestObject.map((node, index)=> {
                if (node.empId != null)
                  return <tr>
                    <td>{(node.empId)}</td>
                    <td>{(node.reportingTo)}</td>
                    <td>{(node.department)}</td>
                    <td>{(node.subDepartment)}</td>
                    <td>{(node.function)}</td>
                    <td>{(node.vertical)}</td>
                    <td>{(node.verticalHead)}</td>
                    <td>{(node.payroll)}</td>
                    <td>{(node.officeLocation)}</td>
                    <td>{node.message}</td>
                  </tr>
              })}
              </tbody>
            </table>
          </ul>
        </nav>

        <h2><u>Leave Balance Upload</u></h2>
        <div>
            <input value={this.state.leaveValue}
               type="file" accept=".csv" name="file2" onChange={this.handleLeaveChange}/>
            <Button disabled={this.state.leave} onClick={()=> {
              axios.post(process.env.REQ_URL + "/leave/upload",
                {data: this.state.leaveObject},
                {withCredentials: true ,
                  headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                this.setState({leaveObject: response.data.data, leave: true,})

              }).catch((error)=> {

              })
            }}>Upload</Button>
        </div>
        <br/>
        <nav>
          <ul style={{'padding':'inherit', 'overflow': 'hidden', 'overflowY': 'scroll', 'overflowX': 'scroll', height: '300px', width: '100%', border: 'thin solid'}}>
            <table className="table table-bordered table-striped">
              <thead>
              <tr>
                <th>empId</th>
                <th>leaveBalance</th>
                <th>reason</th>
                <th>Message</th>
              </tr>
              </thead>
              <tbody>
              {this.state.leaveObject.map((node, index)=> {
                if(node.empId== undefined || node.leaveBalance == undefined)
                  return null;
                else if (node.empId != null)
                  return <tr>
                    <td>{(node.empId)}</td>
                    <td>{(node.leaveBalance)}</td>
                    <td>{(node.reason)}</td>
                    <td>{(node.message)}</td>
                  </tr>
              })}
              </tbody>
            </table>
          </ul>
        </nav>

        <h2><u>Absorption/Exit Upload</u></h2>
        <div>
          <a download={true} href="/public/absorption.csv">Download
            Sample</a><br/>
          <input value={this.state.exitValue}
                 type="file" accept=".csv" name="file3" onChange={this.handleAbsorptionChange}/>
          <Button disabled={this.state.absorption} onClick={()=> {
            axios.post(process.env.REQ_URL + "/exit/uploadExit",
              {data: this.state.exitObject},
              {withCredentials: true ,
                headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
              this.setState({exitObject: response.data.data, absorption: true})

            }).catch((error)=> {

            })

          }}>Upload</Button>
        </div>
        <br/>
        <nav>
          <ul style={{'padding':'inherit', 'overflow': 'hidden', 'overflowY': 'scroll', 'overflowX': 'scroll', height: '300px', width: '100%', border: 'thin solid'}}>
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>oldEmpId</th>
                  <th>dateOfResignation</th>
                  <th>dateOfLeaving</th>
                  <th>typeOfExit</th>
                  <th>noticePeriodStatus</th>
                  <th>absorption</th>
                  <th>newPayroll</th>
                  <th>dateOfJoining</th>
                  <th>Message</th>
                </tr>
              </thead>
              <tbody>
                {this.state.exitObject.map((node, index)=> {
                  if(node.oldEmpId== undefined )
                    return <tr>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>INVALID DATA</td>
                    </tr>
                  else if (node.oldEmpId != null)
                    return <tr>
                      <td>{(node.oldEmpId)}</td>
                      <td>{(node.dateOfResignation)}</td>
                      <td>{(node.dateOfLeaving)}</td>
                      <td>{(node.typeOfExit)}</td>
                      <td>{(node.noticePeriodStatus)}</td>
                      <td>{(node.absorption)}</td>
                      <td>{(node.newPayroll)}</td>
                      <td>{(node.dateOfJoining)}</td>
                      <td>{(node.message)}</td>
                    </tr>
                })}
              </tbody>
            </table>
          </ul>
        </nav>

        <h2><u>Personal Details Upload</u></h2>
        <div>
          <a download={true} href="/public/PersonalDetailsUploadSample.csv">Download
            Sample</a><br/>
          <input value={this.state.personalValue}
                 type="file" accept=".csv" name="file4" onChange={this.handlePersonalChange}/>
          <Button disabled={this.state.personal} onClick={()=> {
            axios.post(process.env.REQ_URL + "/personalUpload",
              {data: this.state.personalObject},
              {withCredentials: true ,
                headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
              this.setState({personalObject: response.data.data, personal: true})

            }).catch((error)=> {
              this.setState({personal: !this.state.personal})
            })

          }}>Upload</Button>
        </div>
        <br/>
        <nav>
          <ul style={{'padding':'inherit', 'overflow': 'hidden', 'overflowY': 'scroll', 'overflowX': 'scroll', height: '300px', width: '100%', border: 'thin solid'}}>
            <table className="table table-bordered table-striped">
              <thead>
              <tr>
                <th>empId</th>
                <th style={{'white-space':'nowrap'}}>empDOB (YYYY-MM-DD)</th>
                <th>empGender</th>
                <th>empAnivarsary</th>
                <th>empSpouseName</th>
                <th>empFatherName</th>
                <th>empMotherName</th>
                <th>maritalStatus</th>
                <th>empChild1</th>
                <th>empChild2</th>
                <th>empPrimaryContactNo</th>
                <th>empEmergencyNo</th>
                <th>empPersonalEmailId</th>
                <th>empAddress</th>
                <th>empPanNo</th>
                <th>empAccountNo</th>
                <th>empBanker</th>
                <th>empAadharNo</th>
                <th>empIFCSNo</th>
                <th>empUAN</th>
                <th>message</th>
              </tr>
              </thead>
              <tbody>
              {this.state.personalObject.map((node, index)=> {
                if(node.empId== undefined )
                  return <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>INVALID DATA</td>
                  </tr>
                else if (node.empId != null)
                  return <tr>
                    <td>{(node.empId)}</td>
                    <td>{(node.empDOB)}</td>
                    <td>{(node.empGender)}</td>
                    <td>{(node.empAnivarsary)}</td>
                    <td>{(node.empSpouseName)}</td>
                    <td>{(node.empFatherName)}</td>
                    <td>{(node.empMotherName)}</td>
                    <td>{(node.maritalStatus)}</td>
                    <td>{(node.empChild1)}</td>
                    <td>{(node.empChild2)}</td>
                    <td>{(node.empPrimaryContactNo)}</td>
                    <td>{(node.empEmergencyNo)}</td>
                    <td>{(node.empPersonalEmailId)}</td>
                    <td>{(node.empAddress)}</td>
                    <td>{(node.empPanNo)}</td>
                    <td>{(node.empAccountNo)}</td>
                    <td>{(node.empBanker)}</td>
                    <td>{(node.empAadharNo)}</td>
                    <td>{(node.empIFCSNo)}</td>
                    <td>{(node.empUAN)}</td>
                    <td>{(node.message)}</td>
                  </tr>
              })}
              </tbody>
            </table>
          </ul>
        </nav>
      </div>
    );
  }
}

UploadHome.propTypes = {};

export default UploadHome;





/** WEBPACK FOOTER **
 ** ./src/feature/hradmin/upload/UploadHome.js
 **/